import i18n from "../../i18n/index";
import OrderResendService from "../../services/orders/OrderResendService.js";
import dayjs from "dayjs";
import XLSX from 'xlsx';

export default {
  components: {
  },
  data: () => ({
      headers: [{
      id: 0,
      text: i18n.t('headers.load-date'),
      sortable: false,
      value: "shippingDate"
  },
  {
      id: 1,
      text: i18n.t('headers.user'),
      sortable: false,
      value: "number"
  },
  {
    id: 2,
    text: i18n.t('headers.patient-name'),
    sortable: false,
    value: "number"
},
  {
      id: 3,
      text: i18n.t('headers.total-orders'),
      sortable: false,
      value: "patient_document"
  },
  {
      id: 4,
      text: i18n.t('headers.total-errors'),
      sortable: false,
      value: "patient_name"
  },
  {
      id: 5,
      text: i18n.t('headers.errors-detail'),
      value: "status",
      sortable: false
  },
  
  ],
    logs: [],
    totallogs: 0,
    rowsPerPageItems: [5, 10],
    pagination: {},
    providers: [],
    provider: {
      id: '',
      name: '',
      fiscalNumber: '',
      active: ''
    },
    copayments: [],
    searchTerm: '',
    file: '',
    selectedProviderId: '',
    loaded: false,
    loading: false,
    orderNumber: '',
    searchButtonLoading: false,
    loadedOrder: false,
    maxDatePreviewDelivery: '',
    orderDetails: '',
    updating: false,
    newStatusSelect : null,
    disabled: false 
  }),
  async created() {
    this.maxDatePreviewDelivery = dayjs(new Date()).format("YYYY-MM-DD")
  },

  computed: {
    customHeaders() {
        return this.headers
    }
  },

  watch: {
    pagination: {
      handler() {
        this.getLog();
      },
      deep: true
  }
  },

  methods: {
    showColumn(i) {
      return !this.enabledColumns || i >= this.enabledColumns.length || this.enabledColumns[i];
    },
    
    async updateOrder () {
      try {
        this.searchButtonLoading = true
        if (!this.orderNumber || !/^\d+$/.test(this.orderNumber)) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'Debe ingresar un número de pedido válido'
          })
          this.searchButtonLoading = false
          return
        }
        let response = await OrderResendService.resendOrder(this.orderNumber)
        if (response && response.status === 200) {
            this.$notify({
                group: 'app',
                type: 'success',
                text: 'El pedido va a ser reenviado al proveedor'
            })
            this.orderNumber= ''
        } else {
            this.$notify({
                group: 'app',
                type: 'error',
                text: 'No se pudo reenviar el pedido'
            })
        }
        this.searchButtonLoading = false
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error.message || 'Error al reenviar el pedido'
        })
        this.searchButtonLoading = false
      }      
    },
    
    onChangeFileUpload() {
      if (this.$refs.file.files[0] !== undefined) {
        this.file = this.$refs.file.files[0]
        this.loaded = true
      } else {
        this.loaded = false
      }
    },
    downloadTemplate () {
      const columns = XLSX.utils.json_to_sheet([{pedido: 1 }, {pedido: 2 }, {pedido: 3 }])
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, columns, 'pedidos')
      XLSX.writeFile(wb, 'plantilla_reenvio_pedidos.xlsx')
    },

    async updateOrders () {
      try {
        if (this.newStatusSelect === null ){
          return this.$notify({
            group: 'app',
            type: 'error',
            text: 'Debe seleccionar el nuevo estado'
          })
        }
        this.orderDetails.forEach(item => {
          if (item.newStatus === '' && item.update) {
            this.disabled = true 
            throw  ('Debe seleccionar el nuevo estado');
          }
        })
        this.updating = true
        const data = {
          order: this.order,
          orderDetails: this.orderDetails
        }
        let response = await orderService.updateOrderStatus(data)
        this.updating = false
        await this.searchOrder()
        this.$notify({
          group: 'app',
          type: 'success',
          text: 'Pedido actualizado con éxito'
        })
        this.newStatusSelect = null
      } catch (error) {
        this.updating = false
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
      }
    },
    async readFile () {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function (e) {
            let data = e.target.result;
            data = new Uint8Array(data);
            let workbook = XLSX.read(data, {type: 'array'});
            let result = {};
            let i = 0;
            workbook.SheetNames.forEach(function (sheetName) {
                let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                if (roa.length) {
                  result[i] = roa;
                  i++;
                }
            });
            resolve(result);
        };
        reader.onerror = function(event) {
          reader.abort();
          reject(reader.error)
        };
        reader.readAsArrayBuffer(this.file);
      });
    },

    async submitForm() {
      try {
        if (this.file !== undefined && this.file !== '') {
          this.loading = true

          const dataFromExcel = await this.readFile();
          if (dataFromExcel[0].length === 0) {
            this.$notify({
              group: 'app',
              type: 'error',
              text: 'El archivo no contiene información'
            })
            return
          }

          for (let i = 0; i < dataFromExcel[0].length; i++) {
            const row = dataFromExcel[0][i];
            if (!row.hasOwnProperty('pedido')) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene un número de pedido en la línea ${i + 1}`
              })
              return
            }
            if (!/^\d+$/.test(row.pedido)) {
              this.$notify({
                group: 'app',
                type: 'error',
                text: `El archivo no contiene un número de pedido válido en la línea ${i + 1}`
              })
              return
            }
          }
          const data = {
            data: dataFromExcel[0]
          }
          let response = await OrderResendService.resendOrders(data)
            if (response && response.status === 200) {
                this.$notify({
                    group: 'app',
                    type: 'success',
                    text: 'Se han reenviado los pedidos al proveedor'
                })
            } else {
                this.$notify({
                group: 'app',
                type: 'error',
                text: 'No se pudo cargar el archivo de reenvío de pedidos'
                })
                this.loading = false
                return
            }
          
          this.loading = false
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'No ha cargado el archivo de cambios de estado'
          })
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
      }
    },

    async getLog(){
      this.loading = true;
      this.orders = [];
      OrderResendService.getLog().then(
        data => {
          console.log(data)
          this.loading = false;
          this.logs = data.data;
          this.totalOrders = data.data.length;
      })
    },

    
     formatearFecha(fechaISO) {
      const fecha = new Date(fechaISO);
    
      const dia = String(fecha.getDate()).padStart(2, '0');
      const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Ojo: Enero es 0
      const anio = fecha.getFullYear();
    
      const horas = String(fecha.getHours()).padStart(2, '0');
      const minutos = String(fecha.getMinutes()).padStart(2, '0');
      const segundos = String(fecha.getSeconds()).padStart(2, '0');
    
      return `${dia}-${mes}-${anio} ${horas}:${minutos}:${segundos}`;
    },

    descargarCSV(errorDetail) {
      if (!errorDetail) {
        console.error('No hay datos para descargar');
        return;
      }
    
      const rows = errorDetail.split(',');
      const csvContent = rows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'errores.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
